import { RecognisedHeaderLabels } from 'common/enums/known-data-enums.js';
import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowEdmTableData } from './table-enums.js';

const holeSizeMap = new Map();

holeSizeMap.set(KnowEdmTableData.DepthFrom, {
  key: KnowEdmTableData.DepthFrom,
  label: RecognisedHeaderLabels.DepthFrom,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

holeSizeMap.set(KnowEdmTableData.DepthTo, {
  key: KnowEdmTableData.DepthTo,
  label: RecognisedHeaderLabels.DepthTo,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

holeSizeMap.set(KnowEdmTableData.HoleSize, {
  key: KnowEdmTableData.HoleSize,
  label: RecognisedHeaderLabels.HoleSize,
  unit: defaultUnits.get(QuantitiesTypes.Diameter),
  quantity: QuantitiesTypes.Diameter,
});

export { holeSizeMap };
